import { useState } from 'react';
import { maskHeaderValue } from '@reqshare/shared';
import './SensitiveValue.scss';

interface SensitiveValueProps {
  name: string;
  value: string;
}

export function SensitiveValue({ name, value }: SensitiveValueProps) {
  const [revealed, setRevealed] = useState(false);

  const displayValue = revealed ? value : maskHeaderValue(name, value);

  return (
    <button
      className={`sensitive-value ${revealed ? 'sensitive-value--revealed' : ''}`}
      onClick={() => setRevealed((prev) => !prev)}
      title={revealed ? 'Click to hide' : 'Click to reveal'}
      type="button"
    >
      <span className="sensitive-value__text">{displayValue}</span>
      <span className="sensitive-value__icon">
        {revealed ? '🙈' : '👁'}
      </span>
    </button>
  );
}
